var map = {
	"./About/doctor1.png": 157,
	"./About/doctor2.png": 410,
	"./Banner.jpg": 411,
	"./Banner1.jpg": 412,
	"./Banner10.jpg": 234,
	"./Banner2.jpg": 413,
	"./Banner3.jpg": 414,
	"./Banner4.jpg": 415,
	"./Banner5.jpg": 416,
	"./Banner6.jpg": 417,
	"./Banner7.jpg": 418,
	"./Banner8.jpg": 419,
	"./Banner8_1.jpg": 420,
	"./Banner9.jpg": 421,
	"./Contact/blik.png": 163,
	"./Contact/mastercard.png": 164,
	"./Contact/visa.png": 165,
	"./LogoHeads.png": 422,
	"./LogoHeads_Black.png": 423,
	"./LogoHeads_Gray.png": 166,
	"./LogoHeads_Whit_30.png": 424,
	"./LogoHeads_White.png": 425,
	"./LogoHeads_White_100.png": 235,
	"./NewBanner/b10.jpg": 426,
	"./NewBanner/b11.jpg": 427,
	"./NewBanner/b12.jpg": 428,
	"./NewBanner/b2.jpg": 429,
	"./NewBanner/b3.jpg": 430,
	"./NewBanner/b5.jpg": 431,
	"./NewBanner/b6.jpg": 432,
	"./NewBanner/b8.jpg": 433,
	"./flags/pl.png": 434,
	"./flags/poland.png": 231,
	"./flags/ua.png": 435,
	"./flags/ukraine.png": 232,
	"./flags/united-kingdom.png": 436,
	"./original.jpg": 437,
	"./service/back.jpg": 438,
	"./service/s0 — kopia.jpg": 439,
	"./service/s0.jpg": 167,
	"./service/s1.jpg": 168,
	"./service/s10 — kopia.jpg": 440,
	"./service/s10.jpg": 169,
	"./service/s11 — kopia.jpg": 441,
	"./service/s11.jpg": 170,
	"./service/s12 — kopia.jpg": 442,
	"./service/s12.jpg": 443,
	"./service/s13.jpg": 444,
	"./service/s2.jpg": 171,
	"./service/s3.jpg": 172,
	"./service/s4.jpg": 173,
	"./service/s5.jpg": 174,
	"./service/s6.jpg": 175,
	"./service/s7.jpg": 176,
	"./service/s8.jpg": 177,
	"./service/s9 — kopia.jpg": 445,
	"./service/s9.jpg": 178
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) { // check for number or string
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return id;
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 233;